import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import Plugins from "./plugins";

Vue.config.productionTip = false;
Vue.use(Plugins);

window._Vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
